import commonActionCreators from '../../../../shared/store/common/action-creators';
import ApiService from '../../../../shared/services/api-service';
import tasksCommitTypes from '../commit-types';
import notificationsActionsCreator from '../../notifications/action-creators';

const taskResponsesActionCreators = {
  // fetchForUser(userId) {
  //   return async (dispatch) => {
  //     dispatch(this.setIsLoading('fetchTaskResponses'));
  //     const data = await ApiService.get(`/api/v1/oits/${userId}/task-responses`)
  //       .then(response => response.data)
  //       .catch(error => ({ error }));
  //     dispatch(this.setIsLoading('fetchTaskResponses'));
  //     if (data.error) {
  //       dispatch(commonActionCreators.handleApiError(data.error));
  //     } else {
  //       dispatch(this.setTaskResponsesForUser(data.data));
  //       dispatch(this.setTaskResponsesMapForUser(data.data));
  //     }
  //   };
  // },

  // setTaskResponsesForUser(taskResponses) {
  //   return {
  //     type: tasksCommitTypes.SET_TASK_RESPONSES_FOR_USER,
  //     taskResponses,
  //   };
  // },

  // setTaskResponsesMapForUser(taskResponses) {
  //   return {
  //     type: tasksCommitTypes.SET_TASK_RESPONSES_MAP_FOR_USER,
  //     taskResponses,
  //   };
  // },

  // createTaskResponse(taskResponse) {
  //   return async (dispatch) => {
  //     dispatch(this.setIsLoading('createTaskResponse'));
  //     dispatch(this.pushTaskResponseToMap(taskResponse));

  //     const data = await ApiService.post('/api/v1/task-responses', taskResponse)
  //       .then(response => response.data)
  //       .catch(error => ({ error }));

  //     dispatch(this.setIsLoading('createTaskResponse'));
  //     if (data.error) {
  //       dispatch(commonActionCreators.handleApiError(data.error));
  //     } else {
  //       dispatch(notificationsActionsCreator.addSavedSuccessfully('Task response saved'));
  //       dispatch(this.pushTaskResponse(data.data));
  //     }
  //   };
  // },

  // acknowledgeTasksResponses(taskResponses) {
  //   return async (dispatch) => {
  //     dispatch(this.setIsLoading('acknowledgeTasksResponses'));

  //     return Promise.all(taskResponses.map(({ guid }) =>
  //       ApiService.post(`/api/v1/task-responses/${guid}/acknowledge`, {
  //         acknowledgedAt: new Date(),
  //       }).then(response => response.data)))
  //       .then(responses =>
  //         responses.map(({ data }) => {
  //           dispatch(this.patchTaskResponse(data));
  //         }))
  //       .then(() => {
  //         dispatch(notificationsActionsCreator.addSavedSuccessfully('Tasks acknowledged'));
  //       });
  //   };
  // },

  // signTaskGroup(taskResponses) {
  //   return async (dispatch) => {
  //     dispatch(this.setIsLoading('acknowledgeTasksResponses'));
  //     return Promise.all(taskResponses.map(({ guid, response }) =>
  //       ApiService.put(`/api/v1/task-responses/${guid}`, {
  //         response,
  //         responseDate: new Date(),
  //         signedAt: new Date(),
  //       }).then(response => response.data)))
  //       .then(responses =>
  //         responses.map(({ data }) => {
  //           dispatch(this.patchTaskResponse(data));
  //         }))
  //       .then(() => {
  //         dispatch(notificationsActionsCreator.addSavedSuccessfully('Tasks signed'));
  //       });
  //   };
  // },

  // pushTaskResponse(taskResponse) {
  //   return {
  //     type: tasksCommitTypes.PUSH_TASK_RESPONSE,
  //     taskResponse,
  //   };
  // },

  // pushTaskResponseToMap(taskResponse) {
  //   return {
  //     type: tasksCommitTypes.PUSH_TASK_RESPONSE_TO_MAP,
  //     taskResponse,
  //   };
  // },

  // updateTaskResponse(taskGuid, taskResponseGuid, response) {
  //   return async (dispatch) => {
  //     dispatch(this.setIsLoading('updateTaskResponse'));
  //     dispatch(this.patchTaskResponseToMap(taskGuid, taskResponseGuid, response));

  //     const data = await ApiService.patch(
  //       `/api/v1/task-responses/${taskResponseGuid}`,
  //       {
  //         response,
  //         responseDate: new Date(),
  //         signedAt: null,
  //       },
  //     )
  //       .then(response => response.data)
  //       .catch(error => ({ error }));

  //     dispatch(this.setIsLoading('updateTaskResponse'));
  //     if (data.error) {
  //       dispatch(commonActionCreators.handleApiError(data.error));
  //     } else {
  //       dispatch(this.patchTaskResponse(data.data));
  //       dispatch(notificationsActionsCreator.addSavedSuccessfully('Tasks response updated'));
  //     }
  //   };
  // },

  // patchTaskResponse(taskResponse) {
  //   return {
  //     type: tasksCommitTypes.PATCH_TASK_RESPONSE,
  //     taskResponse,
  //   };
  // },

  // patchTaskResponseToMap(taskGuid, taskResponseGuid, response) {
  //   return {
  //     type: tasksCommitTypes.PATCH_TASK_RESPONSE_TO_MAP,
  //     taskGuid,
  //     taskResponseGuid,
  //     response,
  //   };
  // },

  // setIsLoading(isLoading) {
  //   return {
  //     isLoading,
  //     type: tasksCommitTypes.SET_TASK_IS_LOADING,
  //   };
  // },
};

export default taskResponsesActionCreators;
